import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  icon: {
    position: 'absolute',
    right: -10,
    top: -12,
    backgroundColor: theme.palette.primary.contrastText
  },
  red: {
    color: 'red'
  }
}))

export {
  useStyles
}
